'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepConnector = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _anchor = require('antd/lib/anchor');

var _anchor2 = _interopRequireDefault(_anchor);

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StepConnector = exports.StepConnector = (_temp = _class = function (_React$PureComponent) {
  _inherits(StepConnector, _React$PureComponent);

  function StepConnector(props) {
    _classCallCheck(this, StepConnector);

    var _this = _possibleConstructorReturn(this, (StepConnector.__proto__ || Object.getPrototypeOf(StepConnector)).call(this, props));

    _this.handleStep = function (activeStep, activeTab) {
      _this.props.steps.forEach(function (step) {
        var dom = step.getContainer ? step.getContainer(step.id) : document.getElementById(step.id);
        if (step.tab === activeTab) {
          dom.style.display = 'block';
        } else {
          dom.style.display = 'none';
        }
      });
      _this.setState({
        activeStep: activeStep,
        activeTab: activeTab
      });
    };

    var firstStep = props.steps[0] || {};
    _this.state = {
      activeStep: 0,
      activeTab: firstStep.tab
    };
    return _this;
  }

  _createClass(StepConnector, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.activeStep !== undefined && nextProps.activeStep !== this.state.activeStep) {
        this.handleStep(nextProps.activeStep, nextProps.steps[nextProps.activeStep].tab);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var activeStep = this.state.activeStep;
      var steps = this.props.steps;

      // return (<Stepper nonLinear activeStep={activeStep} style={{height: height}}>
      //   {steps.map((label) => (
      //     <Step key={label}>
      //       <StepButton onClick={this.handleStep} completed={completed}>
      //         {label}
      //       </StepButton>
      //     </Step>
      //   ))}
      // </Stepper>);

      return _react2.default.createElement(
        _anchor2.default,
        { affix: false, className: 'o-com-stepConnector' },
        steps.map(function (step, index) {
          return [_react2.default.createElement(
            'div',
            { key: index, className: 'o-com-stepConnector_elem-step' },
            _react2.default.createElement(
              'button',
              { tabIndex: index, type: 'button', className: 'o-com-stepConnector_elem-step_btn', onClick: function onClick() {
                  return _this2.handleStep(index, step.tab);
                } },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'o-com-stepConnector_elem-step_span' + (activeStep === index ? ' active' : '') },
                  _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                      'svg',
                      { viewBox: '0 0 24 24' },
                      _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
                      _react2.default.createElement(
                        'text',
                        { x: '12', y: '16' },
                        index + 1
                      )
                    )
                  ),
                  _react2.default.createElement(_anchor2.default.Link, { href: '#' + step.id, title: step.text })
                )
              )
            )
          ), steps.length - index > 1 ? _react2.default.createElement(
            'div',
            { className: 'o-com-stepConnector_elem-connector' },
            _react2.default.createElement('span', null)
          ) : null];
        })
      );
    }
  }]);

  return StepConnector;
}(_react2.default.PureComponent), _class.propTypes = {
  nonLinear: _propTypes2.default.object,
  height: _propTypes2.default.number,
  steps: _propTypes2.default.array,
  completed: _propTypes2.default.bool,
  activeStep: _propTypes2.default.number
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/components/stepConnector/index.jsx
// module id = 99
// module chunks = 0